module.exports = __webpack_public_path__ + "img/skill_level_2_svg.230d8c21.svg";